import React from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import api from '../services/api';
import { HeaderIOS, IOS } from './shared/MenuLayout';
import EnvioMasivoPanel from './EnvioMasivoPanel';

const EnvioMasivoSunat = ({ modulo='economia' }) => {
  const navigate = useNavigate();
  const user = authService.getCurrentUser();
  const ueId = user?.ueIdEstablecimiento || user?.UeIdEstablecimiento || 0;
  const handleLogout = () => { authService.logout(); navigate(`/${modulo}`); };

  return (
    <Box sx={{ minHeight:'100vh', bgcolor:IOS.bg }}>
      <HeaderIOS titulo="Envío Masivo SUNAT" subtitulo="Economía"
        onHome={()=>navigate(`/${modulo}`)} onLogout={handleLogout}
        nombreCompleto={user?.nombreCompleto||user?.usuario||''}
        avatarLetra={(user?.nombreCompleto||user?.usuario||'U').charAt(0).toUpperCase()} />
      <Box sx={{ maxWidth:1100, mx:'auto', px:{ xs:1.5, sm:2.6 }, pt:2.5, pb:6 }}>
        <EnvioMasivoPanel idUE={ueId} api={api} />
      </Box>
    </Box>
  );
};

export default EnvioMasivoSunat;